import React, { useCallback, useEffect, useState } from 'react';
import * as Styles from './RuleItem.styles';
import {
  DropdownMenu, IconLoading, Toggle, Tooltip,
} from 'gatorcomponents';

const RuleItem = ({
  rulesList,
  rule,
  ruleIndex,
  dropdownList,
  securityLocales,
  handleToggleRuleStatus,
  isMobile,
}) => {
  const [blockedTime, setBlockedTime] = useState(0);

  const blockedUntil = rule.blocked_until || 0;
  const toggleDisabled = !!blockedTime || rule.loading;

  const setPreviousBlockedTime = useCallback(() => {
    const timestamp = blockedUntil;
    const currentTimestamp = Math.floor(Date.now() / 1000);

    if (timestamp === 0) {
      setBlockedTime(0);
    }

    if (timestamp > currentTimestamp) {
      setBlockedTime(timestamp - currentTimestamp);
    }
  }, [blockedUntil]);

  useEffect(() => {
    setPreviousBlockedTime();
  }, [setPreviousBlockedTime]);

  const updateBlockedTime = useCallback(() => {
    setBlockedTime((prevBlockedTime) => {
      if (prevBlockedTime <= 0) {
        return 0;
      }
      return prevBlockedTime - 1;
    });
  }, []);

  useEffect(() => {
    const intervalId = setInterval(updateBlockedTime, 1000);

    return () => clearInterval(intervalId);
  }, [updateBlockedTime]);

  useEffect(() => {
    updateBlockedTime();
  }, [updateBlockedTime]);

  const mountActions = () => (
    <Styles.ActionsContainer>
      <Styles.ToggleLabel onClick={e => !toggleDisabled && handleToggleRuleStatus(rule, e)}>
        <Tooltip
          content={securityLocales.rules.ruleBlockedUntil(rule.enabled, blockedTime)}
          disabled={!blockedTime}
          allowDynamicFit
        >
          <Toggle
            checked={rule.enabled}
            testId={`toggle-rule-${rule.rule_id}`}
            disabled={toggleDisabled}
            controlledByFather
          />
        </Tooltip>
      </Styles.ToggleLabel>
      <DropdownMenu items={dropdownList} customPosition="left" />
      <Styles.LoadingContainer>
        {rule.loading && (
          <IconLoading />
        )}
      </Styles.LoadingContainer>
    </Styles.ActionsContainer>
  );

  if (isMobile) {
    return (
      <Styles.MobileListItem key={`${rule.rule_id}-${rule.value}-mobile`}>
        <Styles.MobileListInfo>
          {securityLocales.blockList.order}
          <Styles.InfoText>
            {ruleIndex + 1}
          </Styles.InfoText>
        </Styles.MobileListInfo>
        <Styles.MobileListInfo>
          {securityLocales.blockList.name}
          <Styles.InfoText>
            {rule.description}
          </Styles.InfoText>
        </Styles.MobileListInfo>
        <Styles.MobileListInfo>
          {securityLocales.blockList.action}
          <Styles.InfoText>
            {securityLocales.traficBlock.ruleTypes[rule.lock_type].label}
          </Styles.InfoText>
        </Styles.MobileListInfo>
        <Styles.MobileListInfo $actions>
          {securityLocales.blockList.toggleOn}
          <Styles.InfoText>
            {mountActions()}
          </Styles.InfoText>
        </Styles.MobileListInfo>
      </Styles.MobileListItem>
    );
  }

  return (
    <Styles.TableBody key={`${rule.rule_id}-${rule.value}-table`}>
      <Styles.TableRow $lastRow={ruleIndex === rulesList.length - 1}>
        <Styles.TableCell colspan="1">{ruleIndex + 1}</Styles.TableCell>
        <Styles.TableCell colspan="2">{rule.description}</Styles.TableCell>
        <Styles.TableCell colspan="2">{securityLocales.traficBlock.ruleTypes[rule.lock_type].label}</Styles.TableCell>
        <Styles.TableCell colspan="1">
          {mountActions()}
        </Styles.TableCell>
      </Styles.TableRow>
    </Styles.TableBody>
  );
};

export default RuleItem;
